<template>
  <div class="supplierDetail">
    <div class="oneCon">
      <div class="widthCon">
        <div class="left">
        <img :src="detail.supplier_logo_img" @error="setDefaultImg" alt="" />
        <div class="textCon">
          <p class="firstLine">{{ detail.supplier_name }}</p>
          <p class="secondLine">主营业务：{{ detail.main_business }}</p>
        </div>
      </div>
      <div class="right">
        <div class="content">
          <p class="firstLine">{{ detail.goods_count }}+</p>
          <p class="secondLine">商品总数</p>
        </div>
        <div class="content">
          <p class="firstLine">{{ detail.goods_negative_rate }}%</p>
          <p class="secondLine">商品差评率</p>
        </div>
      </div>
      </div>
    </div>
    <div class="twoCon">
      <div class="topCon">
        <div class="left">
          <div class="title">企业介绍</div>
          <div class="text">{{ detail.copywriting_introduction ?  detail.copywriting_introduction : '生产企业暂时无介绍'}}</div>
        </div>
        <div class="right" @click="showDialog">
          联系企业
          <img src="../assets/btnIcon.png" alt="" />
        </div>
      </div>
      <div class="bottomCon" v-if="detail.list && detail.list.length > 0">
        <div class="con">
          <el-carousel arrow="always" :autoplay="false" height="400px">
            <el-carousel-item v-for="(item, index) in detail.list" :key="index">
              <video
                v-if="detail.isVideo && index === 0"
                :src="item"
                controls
              ></video>
              <img v-else :src="item" @click="showBigImg(item)" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="threeCon" v-if="partnerList && partnerList.length > 0">
      <div class="title">生产企业合作伙伴</div>
      <div class="content">
        <el-row :gutter="46">
          <el-col :span="8" v-for="(item, index) in partnerList" :key="index">
            <div class="list">
              <img
                :src="item.supplier_logo_img"
                @error="setDefaultImg"
                alt=""
              />
              <div class="title">{{ item.supplier_name }}</div>
              <div class="text">{{ item.copywriting_introduction }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="fourCon" v-if="shopList && shopList.length > 0">
      <div class="title">签约店铺</div>
      <el-row class="content" :gutter="53">
        <el-col :span="8" v-for="(item,index) in shopList" :key="index">
          <div class="list">
            <img :src="item.shop_logo_img" @error="setDefaultImg2" alt="">
            <span>{{item.shop_name}}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <codeDialogVue ref="codeDialogVue" />

    <div v-if="showImg" class="imgCon" @click="showImg = false">
      <img :src="imgUrl" @click="showBigImg(item)" alt="" />
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import codeDialogVue from "@/components/codeDialog.vue";
export default {
  components: {
    codeDialogVue: codeDialogVue,
  },
  data() {
    return {
      detail: {},
      supplier_id: "",
      partnerList: [],
      shopList: [],
      imgUrl: "",
      showImg: false,
    };
  },
  mounted() {
    this.supplier_id = this.$route.query.supplier_id;
    this.getDetail(this.supplier_id);
    this.getPartners();
    this.getSignShop();
  },
  methods: {
    showBigImg(item) {
      this.showImg = true;
      this.imgUrl = item;
    },
    showDialog() {
      this.$refs.codeDialogVue.init(2, this.supplier_id);
    },
    getDetail(supplier_id) {
      $.ajax({
        type: "get",
        url: "/officialapi/supplier/detail",
        async: true,
        data: {
          supplier_id: supplier_id,
        },
        success: (data) => {
          if (data["code"] == 0) {
            this.detail = data.data;
            document.title = "星元计划-" + this.detail.supplier_name;
            this.detail.list = [];
            if (this.detail.video_introduction) {
              this.detail.list.push(this.detail.video_introduction);
              this.detail.isVideo = true;
            }
            var enterprise_album = this.detail.enterprise_album ? this.detail.enterprise_album.split(",") : []
            if (enterprise_album && enterprise_album.length > 0) {
              this.detail.list.push(...enterprise_album);
            }
          } else {
            this.$message.error(data.msg);
          }
        },
      });
    },
    getPartners() {
      $.ajax({
        type: "get",
        url: "/officialapi/supplier/getPartners",
        async: true,
        data: {
          supplier_id: this.supplier_id,
          page: 1,
          page_size: 10000,
        },
        success: (data) => {
          if (data["code"] == 0) {
            this.partnerList = data.data.items;
          } else {
            this.$message.error(data.msg);
          }
        },
      });
    },
    getSignShop() {
      $.ajax({
        type: "get",
        url: "/officialapi/supplier/getSignShop",
        async: true,
        data: {
          supplier_id: this.supplier_id,
        },
        success: (data) => {
          if (data["code"] == 0) {
            this.shopList = data.data.items;
          } else {
            this.$message.error(data.msg);
          }
        },
      });
    },
    setDefaultImg(event) {
      event.target.src = require("../assets/head1.png");
    },
    setDefaultImg2(event) {
      event.target.src = require("../assets/head2.png");
    },
  },
};
</script>
<style lang="less" scoped>
.imgCon{
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.5);
  z-index: 9999;
  img{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    max-width: 100%;
    height: auto;
  }
}
.el-carousel__item {
  width: calc(100% - 180px);
  margin-left: 100px;
  height: 400px;
  border-radius: 10px;
  video {
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
  }
}
/deep/.el-carousel .el-carousel__indicators--horizontal {
  display: none;
}
.supplierDetail {
  .oneCon {
    height: 214px;
    width: 100%;
    background: linear-gradient(180deg, #dae6ff 0%, rgba(228, 237, 255, 0) 99%);
    box-sizing: border-box;
    .widthCon{
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 1200px;
      margin: 0 auto;
      height: 100%;
    } 
    .left {
      display: flex;
      align-items: center;
      flex: 1;
      img {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        margin-right: 26px;
      }
      .textCon {
        .firstLine {
          font-family: Source Han Sans;
          font-size: 30px;
          font-weight: bold;
          line-height: 22px;
          letter-spacing: normal;
          color: #222222;
          margin-bottom: 20px;
        }
        .secondLine {
          font-family: Source Han Sans;
          font-size: 20px;
          font-weight: normal;
          line-height: 22px;
          letter-spacing: normal;
          color: #666666;
        }
      }
    }
    .right {
      flex: 0 0 540px;
      .content:first-child{
        margin-right: 36px;
      }
      .content {
        display: inline-block;
        width: 234px;
        height: 130px;
        border-radius: 10px;
        background: #ffffff;
        text-align: center;
        .firstLine {
          font-family: Source Han Sans;
          font-size: 40px;
          font-weight: bold;
          line-height: 34px;
          text-align: center;
          letter-spacing: normal;
          color: #4a90e2;
          margin-bottom: 10px;
          margin-top: 25px;
        }
        .secondLine {
          font-family: Source Han Sans;
          font-size: 20px;
          font-weight: normal;
          line-height: 34px;
          letter-spacing: normal;
          color: #666666;
        }
      }
    }
  }
  .twoCon {
    padding: 33px 0px 60px 0px;
    width: 1200px;
    box-sizing: border-box;
    margin: 0 auto;
    .topCon {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        margin-right: 241px;
        .title {
          font-family: Source Han Sans;
          font-size: 30px;
          font-weight: bold;
          line-height: 34px;
          letter-spacing: normal;
          color: #222222;
          margin-bottom: 25px;
        }
        .text {
          font-family: Source Han Sans;
          font-size: 20px;
          font-weight: normal;
          line-height: 34px;
          letter-spacing: normal;
          color: #222222;
          text-indent: 2em;
text-align: justify;
        }
      }
      .right {
        width: 173px;
        height: 50px;
        border-radius: 6px;
        background: #4a90e2;
        font-family: Source Han Sans;
        font-size: 16px;
        font-weight: 500;
        line-height: 34px;
        letter-spacing: 0.2em;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 0 0 173px;
        cursor: pointer;
        img {
          width: 18px;
          height: 18px;
          margin-left: 14px;
        }
      }
    }
    .bottomCon {
      margin-top: 64px;
    }
  }
  .threeCon {
    padding: 48px 0px 37px 0px;
    background: #f8fafc;
    .title {
      font-family: Source Han Sans;
      font-size: 30px;
      font-weight: bold;
      line-height: 48px;
      letter-spacing: normal;
      color: #222222;
      margin-bottom: 43px;
      text-align: center;
    }
    .content {
      width: 1200px;
      margin: 0 auto;
      .list {
        height: 100%;
        text-align: center;
        border-radius: 10px;
        background: #ffffff;
        padding: 35px 24px 26px 24px;
        margin-bottom: 43px;
        img {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          margin-bottom: 14px;
        }
        .title {
          font-family: Source Han Sans;
          font-size: 20px;
          font-weight: bold;
          line-height: 34px;
          letter-spacing: normal;
          color: #222222;
          margin-bottom: 14px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .text {
          font-family: Source Han Sans;
          font-size: 16px;
          font-weight: normal;
          line-height: 30px;
          letter-spacing: normal;
          color: #222222;
          text-indent: 2em;
text-align: justify;
          height: 90px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          text-align: left;
        }
      }
    }
  }
  .fourCon{
    background: #FFFFFF;
    padding: 46px 0px 48px 0px;
    width: 1200px;
    margin: 0 auto;
    .title{
      font-family: Source Han Sans;
      font-size: 30px;
      font-weight: bold;
      line-height: 48px;
      text-align: center;
      letter-spacing: normal;
      color: #222222;
      margin-bottom: 50px;
    }
    .content{
      .list{
        border-radius: 6px;
        background: #EBEBEB;
        padding: 10px 0px 10px 16px;
        margin-bottom: 30px;
        display: flex;
        align-items: center;
        img{
          width: 56px;
          height: 56px;
          border-radius: 50%;
          margin-right: 18px;
        }
        span{
          font-family: Source Han Sans;
          font-size: 20px;
          font-weight: bold;
          line-height: 24px;
          text-align: center;
          letter-spacing: normal;
          color: #222222;
        }
      }
    }
  }
}
</style>